/**
 * Formats a timestamp as New Zealand local time (Pacific/Auckland, DST-aware).
 *
 * The backend stores audit log timestamps as UTC (`DateTime.UtcNow`), but MySQL's
 * DATETIME column has no timezone concept, so the JSON that comes back has no 'Z'
 * or offset suffix (e.g. "2026-07-09T01:10:39"). `new Date(...)` on a string like
 * that is parsed as the BROWSER's local time per the ECMAScript spec, not UTC —
 * which silently shows the wrong time for anyone not in UTC+0. This forces UTC
 * parsing before converting to NZ time.
 */
export const formatNZTime = (value?: string | null): string => {
  if (!value) return '-';

  const hasTimezone = /[Zz]|[+-]\d{2}:\d{2}$/.test(value);
  const date = new Date(hasTimezone ? value : `${value}Z`);
  if (isNaN(date.getTime())) return value;

  return date.toLocaleString('en-NZ', {
    timeZone: 'Pacific/Auckland',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};
